import React, { Component } from 'react'
import { Modal, FormGroup, ControlLabel, FormControl, Row, Col } from 'react-bootstrap'

import Validation from 'react-validation'
import Repository from '../../felles/repository'
import { resolve } from '../../dependencies'
import '../../felles/valideringsRegler'

export default class SendVarselModal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            tekst: ''
        }
        this._submit = this._submit.bind(this)

        this._handleTekstEndret = this._handleTekstEndret.bind(this)
    }

    componentDidMount() {
        this._hentSmsMal().then(verdi => this.setState({
            tekst : verdi
        }))
        
    }

    _hentSmsMal() {
        return resolve(Repository).hentSmsMalForKunde()
    }

    _submit = (event) => {
        event.preventDefault()        
        this.props.onSendVarsel(this.state.tekst)
    }

    _handleTekstEndret(data) {
        this.setState({
            tekst: data.target.value
        });
    }

    render() {        
        return (
            <Modal show={this.props.isOpen} onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Send varsel</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Validation.components.Form ref={c => this.form = c} onSubmit={this._submit}>
                        <p>Sender bare SMS til de som ikke er varslet tidligere</p>
                        <p>
                    Flettefelt tilgjengelig: &lt;#Maalernummer#&gt;, &lt;#Maaleradresse#&gt;,
                    &lt;#Dato#&gt; og &lt;#Tidsrom&gt;
                </p>
                        <Row>
                            <Col sm={12} >
                                <FormGroup
                                    controlId="formBasicText"
                                >
                                    <ControlLabel>Meldingstekst*</ControlLabel>
                                    <Validation.components.Textarea
                                        errorClassName='is-invalid-input'
                                        cols="40" rows="5"
                                        validations={['required']}
                                        value={this.state.tekst}
                                        placeholder="Meldingstekst"
                                        onChange={this._handleTekstEndret}
                                        className="form-control"
                                    />
                                    <FormControl.Feedback />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Validation.components.Button className="btn btn-primary" >OK</Validation.components.Button>

                    </Validation.components.Form>
                </Modal.Body>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/planlegging/arbeidsliste/sendvarselModal.jsx